import styled from "styled-components";

export const InnerFooter = styled.div`
  width: 100%;
  background: rgba(18, 30, 60, 1);
`;
